import React , {useState, useEffect}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';

import history from '../../history';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert'; // Import

//Loader
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import VerificaAcceso from '../Utiles/Acceso';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

function ListarPerfiles(props) {

    const [perfiles, setPerfiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mensaje, setMensaje] = useState('');

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    //let codigoRecurso ="#113C";
    //VerificaAcceso(codigoRecurso);
    getDatos()
},[]);



async function getDatos(){
    await axios.get(config.api_url+'/configuracion/perfiles/').then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
          setPerfiles(resp.data.perfiles);
        }
        else{setMensaje(resp.data.mensaje)}
     }).catch(error=>{
       toast.error("Se ha generado un error al traer los datos!");
    })  
}

async function Eliminar(item){
    
    await axios.delete(config.api_url+'/configuracion/perfil/?perfilId='+ item.id).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
          toast.success("Pefil Eliminado")
          getDatos();
        }else{
            toast.error(resp.data.mensaje)
        }
     }).catch(error=>{
       toast.error("Se ha generado un error al traer los datos!");
    })  
}


function verPerfil(id){
    history.push('/configuracion/perfil/?id='+id)
}

const ConfirmaEliminacion = (item) => {
       
    confirmAlert({
      title: 'Confirmación de Eliminación',
      message: 'Estas seguro de eliminar este perfil ' + item.nombre +"?",
      buttons: [
        {
          label: 'Si',
          onClick: () => Eliminar(item)
        },
        {
          label: 'No',
          onClick: () => alert('no')
        }
      ]
    });
};

function NuevoPerfil(){
    history.push('/configuracion/perfil/')
}


   return (       
        <div className="contenedorMantenedor">
            <div className='card' style={{paddingLeft:"2%", paddingRight:"2%", paddingTop:"1%"}}>
                <ToastContainer/>
                <div className='card-header'>
                    
                    <div className="d-flex justify-content-start">
                        <a href='/configuracion/'><i class="bi bi-arrow-left-short"></i> Configuración</a>   
                    </div>
                    <div className='row'>
                        <div className='col-12  d-flex justify-content-center'>
                        <h2> <label>Perfiles</label></h2> 
                        </div>
                    </div>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-2'>
                            <button type="button" class="btn btn-primary" onClick={NuevoPerfil}> <i className="bi bi-plus-circle"></i> Añadir Perfil</button>
                        </div>
                    </div>
                </div>
                
                <BeatLoader color={config.color_loader} loading={loading} css={override} size={50} />
                
                <br></br>
                <div className='row d-flex justify-content-center'>
                    <div className='col-10'>
                        {mensaje!==""?
                        <div class="alert alert-danger" role="alert">
                            {mensaje}
                        </div>:''}
                    </div>
                </div>
                <div className='row d-flex justify-content-center'>
                    <div className='col-10'>
                        <table className="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col" className='col-md-1'></th>
                                    <th scope="col" className='col-md-1'></th>  
                                    <th scope="col" className='col-md-10'>Nombre</th>           
                                </tr>
                            </thead>
                                <tbody>  
                                    {perfiles.map( perfil=> 
                                    <tr>
                                        <td> <a href="#" className="btn btn-primary" onClick={()=> verPerfil(perfil.id) }> <i className="bi bi-search"></i></a> </td>
                                        <td> <a href="#" className="btn btn-danger" onClick={()=> ConfirmaEliminacion(perfil) }> <i className="bi bi-file-earmark-x"></i></a> </td>
                                        <td>{perfil.nombre}</td>
                                    </tr>)}              
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    
    );
}

export default ListarPerfiles;